var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserList = function SvgIconUserList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.699 13.262a4.75 4.75 0 1 0-6.397 0 7 7 0 0 0-3.583 4.49 1 1 0 0 0 1.937.496 5 5 0 0 1 4.604-3.754 5 5 0 0 0 .48 0 5 5 0 0 1 4.604 3.754 1 1 0 0 0 1.938-.496 7 7 0 0 0-3.583-4.49M7.5 7a2.75 2.75 0 0 0-.216 5.492 7 7 0 0 1 .433 0A2.75 2.75 0 0 0 7.5 7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.5a1 1 0 0 1 1-1h8.625a1 1 0 1 1 0 2H14.25a1 1 0 0 1-1-1M14.25 11a1 1 0 0 0 0 2h8.625a1 1 0 1 0 0-2zM15.5 16.5a1 1 0 0 1 1-1h6.375a1 1 0 1 1 0 2H16.5a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconUserList;